"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9569],{

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 75532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function MyLink(_param) {
    var to = _param.to, href = _param.href, children = _param.children, rest = _objectWithoutProperties(_param, [
        "to",
        "href",
        "children"
    ]);
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, rest, {
        href: href,
        children: children
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({}, rest, {
        href: to,
        children: children
    }));
};


/***/ }),

/***/ 3368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogInfo_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./src/pages/blog/_components/common.styled.js
var common_styled = __webpack_require__(75610);
;// CONCATENATED MODULE: ./src/pages/blog/_components/BlogInfo/blogInfo.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  display: block;\n\n  > :first-child {\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n  }\n\n  > :last-child {\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-top: 28.5714%; /* 7:2 Aspect Ratio */\n  position: relative;\n  border-bottom: 1px solid ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background: white;\n  padding: 22px 24px 30px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  max-width: ",
        "px;\n  min-width: ",
        "px;\n  margin-right: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  font-size: 12px;\n  line-height: 17px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  color: #2c2c2c;\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 0.25rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  color: #565656;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  margin-left: ",
        "px;\n  display: flex;\n  svg {\n    height: ",
        ";\n  }\n  a {\n    ",
        ";\n    font-size: 24px;\n    line-height: ",
        ";\n    color: ",
        " !important;\n    &:hover {\n      color: ",
        " !important;\n      text-decoration: none !important;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 4px;\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  font-size: 12px;\n  line-height: 17px;\n  cursor: pointer;\n\n  transition: color 0.25s ease, border-color 0.25s ease;\n\n  &:hover {\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  &:not(:first-child) {\n    margin-left: 16px;\n  }\n  font-size: 12px;\n  line-height: 17px;\n  color: ",
        ";\n  transition: color 0.25s ease;\n  cursor: pointer;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:before {\n    content: '# ';\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 14px;\n  margin-left: ",
        "px;\n  color: ",
        ";\n  font-size: 12px;\n  line-height: 17px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:first-child) {\n    margin-left: 24px;\n  }\n\n  .text {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var avatarSize = 32;
var blogInfo_styled_colors = {
    primary: colors.B1,
    black: colors.F1,
    borderGray: colors.T2
};
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), common_styled/* borderRadiusSize */.k, common_styled/* borderRadiusSize */.k, common_styled/* borderRadiusSize */.k, common_styled/* borderRadiusSize */.k);
var CoverImageContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), blogInfo_styled_colors.borderGray);
var CoverImage = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
var Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var ActionText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var Author = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var AuthorAvatar = styled_components_browser_esm/* default.a */.ZP.a(_templateObject6(), avatarSize, avatarSize);
var AuthorInfo = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());
var AuthorName = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8());
var AuthorNameBase = styled_components_browser_esm/* default.a */.ZP.a(_templateObject9());
var AuthorNameExtend = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
var AuthorPublishedAt = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11());
var lineHeight = "2rem";
var Title = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12(), avatarSize + 8, lineHeight, mixins/* lineClamp */.Sf(3), lineHeight, blogInfo_styled_colors.black, blogInfo_styled_colors.primary);
var Meta = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13(), avatarSize + 8);
var Category = styled_components_browser_esm/* default.a */.ZP.a(_templateObject14(), common_styled/* borderRadiusSize */.k, blogInfo_styled_colors.borderGray, blogInfo_styled_colors.black, blogInfo_styled_colors.primary, blogInfo_styled_colors.primary);
var Tag = styled_components_browser_esm/* default.a */.ZP.a(_templateObject15(), blogInfo_styled_colors.black, blogInfo_styled_colors.primary);
var Interactions = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16(), avatarSize + 8, blogInfo_styled_colors.black);
var InteractionItem = styled_components_browser_esm/* default.span */.ZP.span(_templateObject17());

// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 3 modules
var avatar = __webpack_require__(24093);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PushpinOutlined.js + 1 modules
var PushpinOutlined = __webpack_require__(57184);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/HeartOutlined.js + 1 modules
var HeartOutlined = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MessageOutlined.js + 1 modules
var MessageOutlined = __webpack_require__(38545);
// EXTERNAL MODULE: ./src/components/MyLink.jsx
var MyLink = __webpack_require__(75532);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
;// CONCATENATED MODULE: ./src/pages/blog/_components/BlogInfo/BlogInfo.component.js










var BlogInfo = function(param) {
    var slug1 = param.slug, _usernameExtends = param.usernameExtends, usernameExtends = _usernameExtends === void 0 ? undefined : _usernameExtends, publishedAt = param.publishedAt, title = param.title, _titleExtends = param.titleExtends, titleExtends = _titleExtends === void 0 ? undefined : _titleExtends, _category = param.category, category = _category === void 0 ? undefined : _category, tags = param.tags, likes = param.likes, comments = param.comments, bottomExtends = param.bottomExtends, _coverImageURL = param.coverImageURL, coverImageURL = _coverImageURL === void 0 ? undefined : _coverImageURL, author = param.author, _recommended = param.recommended, recommended = _recommended === void 0 ? false : _recommended, _getPostUrl = param.getPostUrl, getPostUrl = _getPostUrl === void 0 ? function(slug) {
        return "/blog/".concat(slug);
    } : _getPostUrl, actionText = param.actionText;
    var showRecommendedIcon = (0,react.useContext)(context/* PageDataContext */.A6).showRecommendedIcon;
    var publishedAtFormatted = (0,react.useMemo)(function() {
        if (publishedAt) {
            return dayjs_min_default()(publishedAt).format("YYYY-MM-DD HH:mm");
        } else {
            return "\u672A\u53D1\u5E03";
        }
    }, [
        publishedAt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            coverImageURL && coverImageURL.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImage, {
                    style: {
                        backgroundImage: "url(".concat(JSON.stringify(coverImageURL), ")")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    actionText && actionText.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionText, {
                        children: actionText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Author, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/u/".concat(author.username),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorAvatar, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                        size: avatarSize,
                                        src: author.avatarURL
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorName, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/u/".concat(author.username),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorNameBase, {
                                                    children: author.username || author.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorNameExtend, {
                                                children: usernameExtends
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorPublishedAt, {
                                        children: publishedAtFormatted
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        children: [
                            showRecommendedIcon && recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)(PushpinOutlined/* default */.Z, {
                                style: {
                                    marginRight: 8,
                                    fontSize: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLink/* default */.Z, {
                                href: getPostUrl(slug1),
                                children: title === "" ? " [\u672A\u586B\u5199\u6587\u7AE0\u6807\u9898] " : title
                            }),
                            titleExtends
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta, {
                        children: [
                            category && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/c/".concat(category.slug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                    children: category.name
                                })
                            }),
                            tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog/tag/".concat(tag.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                        children: tag.name
                                    }, tag.id)
                                }, tag.slug);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Interactions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InteractionItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeartOutlined/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text",
                                        children: likes
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InteractionItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageOutlined/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text",
                                        children: comments
                                    })
                                ]
                            })
                        ]
                    }),
                    bottomExtends
                ]
            })
        ]
    });
};
var AuthorShape = prop_types_default().shape({
    id: (prop_types_default()).number.isRequired,
    name: (prop_types_default()).string.isRequired,
    avatarURL: (prop_types_default()).string
});
var MetaShape = prop_types_default().shape({
    id: (prop_types_default()).number.isRequired,
    name: (prop_types_default()).string.isRequired,
    slug: (prop_types_default()).string.isRequired
});
BlogInfo.propTypes = {
    el: (prop_types_default()).string,
    id: (prop_types_default()).number.isRequired,
    slug: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    author: AuthorShape.isRequired,
    category: MetaShape,
    tags: prop_types_default().arrayOf(MetaShape.isRequired),
    publishedAt: (prop_types_default()).string.isRequired,
    likes: (prop_types_default()).number.isRequired,
    comments: (prop_types_default()).number.isRequired,
    coverImageURL: (prop_types_default()).string,
    titleExtends: (prop_types_default()).node,
    usernameExtends: (prop_types_default()).node,
    bottomExtends: (prop_types_default()).node
};
BlogInfo.Tag = Tag;
/* harmony default export */ var BlogInfo_component = (BlogInfo);

;// CONCATENATED MODULE: ./src/pages/blog/_components/BlogInfo/index.js



/***/ }),

/***/ 75610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ borderRadius; },
/* harmony export */   "k": function() { return /* binding */ borderRadiusSize; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var borderRadiusSize = "6px";
var borderRadius = function() {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), borderRadiusSize);
};


/***/ }),

/***/ 99117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ usePrincipal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70780);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62675);




var usePrincipalSsr = function() {
    return {
        loading: false,
        id: undefined,
        authorities: [],
        roles: [],
        hasAuthority: function() {
            return false;
        },
        hasRole: function() {
            return false;
        },
        isAuthor: function() {
            return false;
        },
        isLogin: false
    };
};
var UNAUTHORIZED = {
    id: undefined,
    roles: [],
    authorities: []
};
var usePrincipalBrowser = function() {
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .MeContext */ .io), meData = ref3.meData, isMeValidating = ref3.isMeValidating;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)([
        meData === null || meData === void 0 ? void 0 : meData.username
    ], {
        fetcher: function() {
            return _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_3__.principal();
        }
    }), principal = ref1.data;
    var ref2 = principal !== null && principal !== void 0 ? principal : UNAUTHORIZED, id = ref2.id, roles = ref2.roles, authorities = ref2.authorities;
    var hasRole = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(auth) {
        return roles.indexOf(auth) >= 0;
    }, [
        roles
    ]);
    var hasAuthority = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(auth) {
        return authorities.indexOf(auth) >= 0;
    }, [
        authorities
    ]);
    var isAuthor = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(target) {
        var ref;
        return id !== undefined && (target === null || target === void 0 ? void 0 : (ref = target.author) === null || ref === void 0 ? void 0 : ref.id) === id;
    }, [
        id
    ]);
    var isLogin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return typeof id === "number";
    }, [
        id
    ]);
    // TODO: some thing not correct with principal.isValidating
    var loading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (meData) {
            return isMeValidating || typeof (principal === null || principal === void 0 ? void 0 : principal.id) === "undefined";
        } else {
            return isMeValidating;
        }
    }, [
        meData,
        principal,
        isMeValidating
    ]);
    return {
        roles: roles,
        authorities: authorities,
        hasRole: hasRole,
        hasAuthority: hasAuthority,
        isAuthor: isAuthor,
        isLogin: isLogin,
        id: id,
        loading: loading
    };
};
var usePrincipal =  false ? 0 : usePrincipalBrowser;


/***/ })

}]);